import { Component, Inject, OnDestroy, OnInit,Renderer2 } from '@angular/core';
import { ActivatedRoute,NavigationEnd,Router } from '@angular/router';
import { BrandingConfig } from '@shared/models/branding.model';
import { Constant } from '@shared/utilities/constant';
import { ZoomDetectionService } from '@shared/services/zoom-detection.service'

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  public mySubscription;
  public clientBrandObj: BrandingConfig;
  public videoPath;
  public avatarPath;
  public videoIconPath;
  public avatarIconPath;
  public avatarMobileIconPath;  
  public isVisiblelogo: boolean = false;

  public mainImage: string;
  public chatBackgroundImage: string;
  public logoUrl: string;
  public brandingMobile :string;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private zoomDetectionService: ZoomDetectionService,
    private renderer: Renderer2,
    @Inject(Constant.brandingConfig) private brandingConfig: BrandingConfig
  ) {

  }

  claraclick(){
    window.open(this.avatarPath, '_blank', 'noopener,noreferrer');
  }

  loginbtnclick() {
    const clientId = sessionStorage.getItem(Constant.ClientId);
    if(clientId) {
     this.router.navigate(['/login', clientId]);
    } else {
     this.router.navigateByUrl('/login');
    }
  }
  
  registerbtnclick() {
    
    this.router.navigateByUrl('/register');
  }

  ngOnInit(): void {
    // Detect zoom on component initialization
    this.zoomDetectionService.detectZoom(this.renderer);
    // Detect zoom on window resize
    window.addEventListener('resize', () => this.zoomDetectionService.detectZoom(this.renderer));
        
    this.clientBrandObj = this.brandingConfig;
    this.isVisiblelogo = (this.clientBrandObj.branding_product) ? true : false;

    // we want to keep session client data so we can track client to use after login
    const clientId = sessionStorage.getItem(Constant.ClientId);

    // we want to keep session host domain data so we can track domain to use after login
    const domain = sessionStorage.getItem(Constant.host);

    const clientCode = sessionStorage.getItem(Constant.clientCode);
    window.sessionStorage.clear();
    sessionStorage.clear();

    // we want to keep session data so we can track user activity
    const sessionInfo = localStorage.getItem(Constant.StorageSession);
    
    localStorage.clear();

    sessionStorage.setItem(Constant.host, domain);
    sessionStorage.setItem(Constant.ClientId, clientId);
    sessionStorage.setItem(Constant.clientCode, clientCode);

    localStorage.setItem(Constant.StorageSession, sessionInfo);

    this.deleteAllCookies();
    
    this.route.data.subscribe({
      next: (data) => {
        
        this.videoPath = data.data[0];
        this.avatarPath = data.data[1];
        this.videoIconPath = data.data[2];
        this.avatarIconPath = data.data[3];
        this.avatarMobileIconPath = data.data[4];
        
        this.mainImage = data.data[5];
        this.chatBackgroundImage = data.data[6];
        this.logoUrl = data.data[7];
        this.brandingMobile =data.data[8];

      },
      error: (err) => {
        console.error('Error fetching data', err);
      }
    });
  }
  

  deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
}
